// @ts-nocheck
import ServiceCardImages from '../ServiceCardImages/ServiceCardImages';
import ServiceCardAttachments from '../ServiceCardAttachments/ServiceCardAttachments';
import { Box } from '@mui/material';
import * as PropTypes from 'prop-types';

/**
 * A component for rendering a section of files and images within a service card
 *
 * The component renders a container with the class name `service-view-card__files-section`
 * and inside it renders either a ServiceCardImages component with the images prop
 * or a ServiceCardAttachments component with the attachments prop, if the respective
 * props are present in the servicefields object.
 *
 * @param {Object} servicefields - the fields of the service
 * @returns {JSX.Element} - the JSX element representing a files section
 */
const FilesSection = ({ servicefields }) => {
  return (
    (servicefields?.UPLOADIMAGES || servicefields?.UPLOADATTACHMENTS) && (
      <Box className='service-view-card__files-section'>
        {servicefields?.UPLOADIMAGES && (
          <ServiceCardImages images={servicefields?.UPLOADIMAGES} />
        )}
        {servicefields?.UPLOADATTACHMENTS && (
          <ServiceCardAttachments
            attachments={servicefields?.UPLOADATTACHMENTS}
          />
        )}
      </Box>
    )
  );
};

FilesSection.propTypes = {
  servicefields: PropTypes.object
};

export default FilesSection;
